import { render, staticRenderFns } from "./recalculation.vue?vue&type=template&id=f895f2be"
import script from "./recalculation.vue?vue&type=script&lang=js"
export * from "./recalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports